const basePath =
  process.env.NODE_ENV !== 'production'
    ? 'cdn.mtassets.net'
    : 'cdn.smassets.net';

const theme = {
  // @todo: created ticket to update path once fonts live in CDN for good. https://jira.surveymonkey.com/browse/WRENCH-1128
  assetsBaseUri: `https://${basePath}/assets/wds-core_4_20_1`,
  assetsFontPath: '/fonts/National2Web',
  assetsFontName: "'National 2'",
  assetsFontVersion: 2,
  fontFamily: {
    base:
      "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
    icon: 'Mateo',
  },
  fontSize: {
    bodySm: 13,
    body: 15,
    cardTitle: 16,
    sectionTitle: 26,
    pageTitle: 34,
    hero2: 40,
    hero1: 50,
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
  },
  semanticColor: {
    primary: '#00BF6F',
    success: '#00BF6F',
    info: '#2DCCD3',
    warning: '#F05B24',
    upgrade: '#F9BE00',
    secondary: '#6B787F',
    muted: '#D0D2D3',
  },
  typeColor: {
    dark: '#333E48',
    light: '#FFFFFF',
    darkMuted: '#6B787F',
    lightMuted: '#D0D2D3',
    link: '#007FAA',
    on: {
      primary: '#FFFFFF',
      success: '#FFFFFF',
      info: '#333E48',
      warning: '#FFFFFF',
      upgrade: '#333E48',
      secondary: '#FFFFFF',
      muted: '#333E48',
      link: '#FFFFFF',
    },
  },
  bgColor: {
    bg: '#F7F8FA',
    dark: '#333E48',
    overlay: 'rgba(107, 120, 127, .86)',
    accent: '#EDEEEE',
    light: '#FFFFFF',
  },
  borderColor: {
    border: '#D0D2D3',
    active: '#00BF6F',
    hover: '#9DA5AA',
    muted: '#EDEEEE',
  },
  border: {
    border: '1px solid #D0D2D3',
    borderHover: '1px solid #9DA5AA',
    borderActive: '1px solid #00BF6F',
    borderMuted: '1px solid #EDEEEE',
  },
  dataColor: {
    one: '#507CB6',
    two: '#00BF6F',
    three: '#6BC8CD',
    four: '#F9BE00',
    five: '#7D5E90',
    six: '#DB4D5C',
    seven: '#768086',
    eight: '#D25F90',
    nine: '#A38364',
    ten: '#FF8B4F',
  },
  borderRadius: {
    zero: '0',
    small: '2px',
    medium: '24px',
    large: '50%',
  },
  iconSize: {
    sm: 13,
    md: 16,
    lg: 26,
    xl: 34,
  },
  spacing: {
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 24,
    6: 32,
    7: 64,
    8: 96,
    9: 128,
  },
  breakpoints: {
    xs: '0',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  elevation: {
    shadow: {
      none: 'none',
      sky: '0 2px 4px 0 rgba(0, 0, 0, 0.14)',
      space: '0 2px 8px 0 rgba(0,0,0,0.14)',
    },
  },
  zIndex: {
    none: '0',
    sky: '999',
    space: '9999',
  },
  alert: {
    boxShadow: 'none',
    bgColor: '#333E48',
    typeColor: '#FFFFFF',
    paddingY: 16,
    linkColor: '#FFFFFF',
  },
  avatar: {
    height: {
      sm: 24,
      md: 32,
      lg: 64,
      xl: 96,
    },
    borderRadius: {
      square: '0%',
      rounded: '50%',
    },
    border: '2px solid #FFFFFF',
  },
  badge: {
    height: {
      sm: 22,
      md: 26,
      lg: 30,
    },
    fontSize: {
      sm: 13,
      md: 13,
      lg: 15,
    },
    padding: '1em',
    borderRadius: 24,
    boxShadow: 'none',
  },
  banner: {
    borderRadius: 2,
    bgColor: '#ffffff',
    typeColor: '#333e48',
    markWidth: 8,
    borderSize: 1,
  },
  button: {
    height: {
      sm: 30,
      md: 40,
      lg: 50,
    },
    fontSize: {
      sm: 13,
      md: 15,
      lg: 15,
    },
    padding: {
      sm: 12,
      md: 24,
      lg: 36,
    },
    borderRadius: 2,
    boxShadow: 'none',
  },
  card: {
    borderRadius: 2,
    boxShadow: 'none',
    border: '1px solid #EDEEEE',
    padding: 24,
    bgColor: '#FFFFFF',
  },
  checkbox: {
    bgColorOn: '#00BF6F',
    iconColorOn: '#FFFFFF',
  },
  coachmark: {
    bgColor: '#2DCCD3',
  },
  formGroup: {
    spaceBetween: 8,
  },
  grid: {
    bleed: {
      xs: 16,
      sm: 32,
      md: 32,
      lg: 32,
      xl: 32,
    },
    columns: 12,
    gutter: {
      xs: 16,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
    },
    maxWidth: {
      xs: 'none',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1400px ',
    },
  },
  input: {
    height: {
      sm: 30,
      md: 40,
      lg: 50,
    },
    fontSize: 15,
    padding: {
      sm: 8,
      md: 12,
      lg: 16,
    },
    borderRadius: 2,
  },
  inputGroup: {
    height: {
      sm: 30,
      md: 40,
      lg: 50,
    },
    borderRadius: 2,
    iconColor: '#333E48',
  },
  list: {
    addonIconColor: '#333E48',
    affordanceIconColor: '#6B787F',
    itemHeight: 52,
    labelFontSize: 13,
    markWidth: 4,
  },
  menu: {
    boxShadow: '0 2px 8px 0 rgba(0,0,0,0.14)',
    maxWidth: 300,
    minWidth: 175,
    maxHeight: 325,
  },
  modal: {
    borderRadius: 0,
    headBgColor: '#FFFFFF',
    headTypeColor: '#333E48',
    bodyBgColor: '#EDEEEE',
    bodyTypeColor: '#333E48',
    footBgColor: '#FFFFFF',
    footTypeColor: '#333E48',
    border: '1px solid #333E48',
    boxShadow: 'none',
  },
  pane: {
    bgColor: '#EDEEEE',
    padding: 24,
  },
  progressBar: {
    borderRadius: 'none',
    height: {
      sm: 4,
      md: 8,
      lg: 16,
    },
    fillColor: '#00BF6F',
    trackColor: '#D0D2D3',
  },
  radio: {
    bgColorOn: '#00BF6F',
    iconColorOn: '#FFFFFF',
  },
  textarea: {
    fontSize: 15,
    paddingSm: [4, 8, 4],
    paddingMd: [8, 12, 8],
    paddingLg: [12, 16, 12],
    borderRadius: 2,
  },
  motion: {
    curve: {
      enter: 'cubic-bezier(0, 0, 0, 1)',
      exit: 'cubic-bezier(1, 0, 1, 1)',
      ease: 'cubic-bezier(.2, 0, .1, 1)',
      easeReverse: 'cubic-bezier(.9, 0, .8, 1)',
      bounceStart: 'cubic-bezier(0, 0, .1, 1)',
      bounceEnd: 'cubic-bezier(.2, 0, 0, 1)',
    },
    fade: {
      speed: {
        slow: 300,
        normal: 200,
        fast: 100,
      },
    },
    slide: {
      speed: {
        slow: 450,
        normal: 350,
        fast: 250,
      },
      distance: {
        normal: 25,
        near: 5,
        far: 75,
      },
    },
  },
  multiselect: {
    borderRadius: 2,
  },
  progressCircle: {
    trackColor: '#D0D2D3',
  },
  select: {
    height: {
      sm: 30,
      md: 40,
      lg: 50,
    },
    padding: {
      sm: 8,
      md: 12,
      lg: 16,
    },
    borderRadius: 2,
    iconColor: '#333E48',
    fontSize: 15,
  },
  sheet: {
    width: {
      sm: '320px',
      md: '50%',
      lg: '75%',
    },
  },
  slider: {
    handleBGColor: '#333E48',
    trackBGColor: '#D0D2D3',
    fillBGColor: '#00BF6F',
    borderRadius: 24,
    height: 16,
  },
  // Naming with Comp here because switch is reserved.
  switchComp: {
    track: {
      bgColorOn: '#333E48',
      bgColorOff: '#D0D2D3',
    },
    thumb: {
      bgColorOn: '#00BF6F',
      bgColorOff: '#FFFFFF',
      borderOff: '1px solid #D0D2D3',
    },
    borderRadius: 24,
    height: 16,
    leftOffset: 20,
    width: 40,
  },
  tab: {
    borderRadius: 'none',
    indicatorHeight: 3,
    indicatorColor: '#00BF6F',
    typeColor: '#6B787F',
    fontSize: 13,
    fontWeight: 500,
    paddingY: 12,
    paddingX: 2,
  },
  toast: {
    padding: 24,
    bgColor: '#333E48',
    typeColor: '#FFFFFF',
    borderRadius: 2,
    width: 350,
    titleFontSize: 16,
    bodyTypeSize: 13,
    linkColor: '#FFFFFF',
    boxShadow: 'none',
  },
  popout: {
    width: {
      sm: 275,
      md: 360,
      lg: 445,
    },
    boxShadow: '0 2px 8px 0 rgba(0,0,0,0.14)',
    pipSize: 12,
    borderRadius: 2,
    border: 'none',
    bodyFontSize: 13,
  },
  tooltip: {
    bgColor: '#333E48',
    typeColor: '#FFFFFF',
    borderRadius: 2,
    pipSize: 12,
    fontSize: 13,
    padding: [12, 16],
    fontWeight: 400,
    boxShadow: 'none',
  },
  table: {
    thTypeColor: '#333E48',
    thBgColor: 'transparent',
    thDividerLineColor: 'transparent',
    tdTypeColor: '#333E48',
    tdBgColor: 'transparent',
    cellMinHeight: 50,
    cellPadding: [16, 24],
    fontSize: 15,
  },
};

export default theme;
